var s={card:"resume-glass-card-styles-module_card__u0Y-P",icon:"resume-glass-card-styles-module_icon__H-7ba"};export{s as default};
//# sourceMappingURL=resume-glass-card.styles.module.scss.js.map
